import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const Overlay = _ref => {
  let {
    open,
    onClick
  } = _ref;
  if (!open) {
    return null;
  }
  const overlayClass = 'fixed inset-0 bg-black bg-opacity-40 z-1400';
  return /*#__PURE__*/_jsx("div", {
    className: overlayClass,
    onClick: onClick,
    role: "presentation"
  });
};
Overlay.propTypes = {
  open: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired
};
export default Overlay;
//# sourceMappingURL=Overlay.js.map